import { render } from "./LineChart3.vue?vue&type=template&id=f8270664"
import script from "./LineChart3.vue?vue&type=script&lang=js"
export * from "./LineChart3.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__